import React from "react";
import { toast } from "sonner";
import { Copy } from "@phosphor-icons/react";

export const fullLink = (path) => `${window.location.origin}${path}`;

export const CopyLink = ({ path, testId = "copy-link" }) => {
  const url = fullLink(path);
  const copy = () => navigator.clipboard.writeText(url).then(() => toast.success("Link copied"), () => toast.error("Couldn't copy — select the link and copy it"));
  return (
    <div className="flex items-stretch border-2 border-black">
      <input readOnly value={url} className="flex-1 min-w-0 px-3 py-2 font-mono text-[11px] bg-zinc-50" onFocus={(e) => e.target.select()} data-testid={`${testId}-url`} />
      <button type="button" onClick={copy} data-testid={`${testId}-copy`}
              className="px-3 bg-black text-white text-[10px] uppercase tracking-widest inline-flex items-center gap-1 hover:bg-zinc-800 transition-colors duration-100">
        <Copy size={12} weight="bold" /> Copy
      </button>
    </div>
  );
};
